// The variable `REACT_APP_ENV` is set to "REACT_APP_ENV" at build time.
// This means that the condition `env === "dev"` will always be false for Vite's bundler.
// By using string interpolation below, we prevent the bundler from performing static analysis.
export const getEnv = (): string =>
  (val => (val && val !== "undefined" ? val : "local"))(`${import.meta.env.REACT_APP_ENV}`)

export const isProductionEnv = (): boolean => "production" === getEnv()
export const isStagingEnv = (): boolean => getEnv().includes("staging")
export const isStagingOrProductionEnv = (): boolean => isProductionEnv() || isStagingEnv()
